module.exports = __webpack_public_path__ + "language-dropdown/TR.png";